import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import api from 'modules/queries/api';

const useProjectDelete = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/project/index.raw').LWApiPublicProjectDeleteParamsRawI} params */
			(params) => api.project.apiRaw.delete(params),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['/project/list'],
			});
		},
		onError: snackbarError,
	});
};

export default useProjectDelete;
